import { ILocale } from 'entities/compilationContext/compilation-context';

export class SampleLocale implements ILocale {
  public constructor({ code, language, region }: ILocale) {
    this.code = code;
    this.language = language;
    this.region = region;
  }

  public code?: string;
  public language?: string;
  public region?: string;
}
